<div class="row h-100">
  <section class="col-md-4 super-compos-left-shadow overflow-hidden pe-2">
    <div class="mb-3 mt-2 position-relative">
      <i-title [text]="'email' | translate" level="1"></i-title>
    </div>
    <i-accordion [hideShowAllBtn]="true">
      @if (exchangeParams?.globalMailboxCredentials) {
        <i-accordion-tab [showEditBtn]="false" header="{{ exchangeParams?.globalMailbox }} (globale)">
          @for (box of boites; track box) {
            <div
              class="d-flex align-items-center mt-2 mb-2 cursor--pointer border rounded p-2 bg-light"
              (click)="box.click(exchangeParams?.globalMailbox, 'global'); whichBox = box.value">
              {{ box.label }}
            </div>
          }
        </i-accordion-tab>
      }
      @if (exchangeParams?.hidePersonalBox === false) {
        <i-accordion-tab [showEditBtn]="false" [header]="'exchange.personalInbox' | translate">
          @for (box of boites; track box) {
            <div
              class="d-flex align-items-center mt-2 mb-2 cursor--pointer border rounded p-2 bg-light"
              (click)="box.click('perso', 'perso'); whichBox = box.value">
              {{ box.label }}
            </div>
          }
        </i-accordion-tab>
      }
      @if (exchangeParams?.sharedMailboxes.length > 0) {
        <div>
          @for (shared of exchangeParams?.sharedMailboxes; track shared) {
            <i-accordion-tab [showEditBtn]="false" header="{{ shared }}">
              @for (box of boites; track box) {
                <div
                  class="d-flex align-items-center mt-2 mb-2 cursor--pointer border rounded p-2 bg-light"
                  (click)="box.click(shared, 'shared'); whichBox = box.value">
                  {{ box.label }}
                </div>
              }
              <div class="d-flex align-items-center justify-content-center">
                <i-button
                  [text]="'exchange.deleteSharedInbox' | translate"
                  (click)="deleteShared(exchangeParams?.sharedMailboxes, shared)"
                  styleClass="red"></i-button>
              </div>
            </i-accordion-tab>
          }
        </div>
      }
    </i-accordion>
    <div class="d-flex mt-4 align-items-center justify-content-center">
      <i-button [text]="'exchange.addSharedInbox' | translate" styleClass="green" (click)="openShared = true"></i-button>
    </div>
  </section>
  <!-- HERE IS THE SECTION OF THE ACTIVE ITEM SELECTED IN THE LIST-->
  <section class="col-md-8 active-user">
    <div class="mb-3 mt-2 position-relative">
      <i-title [text]="'exchange.mailList' | translate" level="1"></i-title>
    </div>
    @if (items.length > 0) {
      <i-table
        (onClickRow)="showDialog($event)"
        [height]="'90vh'"
        (onClickDelete)="deleteSelection($event)"
        [paginator]="true"
        class="super-table"
        [columns]="columns"
        [items]="items"
        id="actionCourrierSuperTable"
        [multiselect]="true">
      </i-table>
    }
    @if (items.length === 0) {
      <div class="col-md-12 d-flex align-items-center justify-content-center mt-4">
        <img class="img-fluid" src="./assets/img/decoration/nofiles.svg" width="400" alt="" />
      </div>
    }
  </section>
</div>

<p-dialog
  styleClass="super-compos-modal-content"
  [(visible)]="showLoginModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  appendTo="body"
  [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'exchange.connectToMailbox' | translate }}</h5>
      <div class="d-flex">
        <i-button styleClass="blue me-3" (click)="showLoginModal = false" text="Annuler"></i-button>
        <i-button styleClass="green" (click)="login()" [text]="'login' | translate"></i-button>
      </div>
    </div>
  </p-header>
  <form [formGroup]="formLogin" class="mt-3 mb-3 row">
    <div class="col-md-6">
      <label class="super-compos-label-input">{{ 'login' | translate }} *</label>
      <input type="search" formControlName="login" autofocus class="form-control" autocomplete="new-password" />
    </div>
    <div class="col-md-6">
      <label class="super-compos-label-input">{{ 'password' | translate }}</label>
      <i-input
        [type]="'password'"
        [iInput]="{ placeholder: '' }"
        [control]="formLogin.get('password')"
        [showError]="false"
        styleClass="d-block w-100"></i-input>
    </div>
  </form>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content"
  [(visible)]="openShared"
  [modal]="true"
  [style]="{ width: '50vw' }"
  appendTo="body"
  [closable]="false">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'exchange.addSharedMailbox' | translate }}</h5>
      <div class="d-flex">
        <i-button styleClass="blue me-3" (click)="openShared = false" [text]="'cancel' | translate"></i-button>
        <i-button styleClass="green" (click)="addShared()" [text]="'add' | translate"></i-button>
      </div>
    </div>
  </p-header>
  <div class="mt-3 mb-3 row">
    <div class="col-md-12">
      <label class="super-compos-label-input">{{ 'exchange.sharedMailboxName' | translate }}</label>
      <input type="search" [(ngModel)]="sharedEmailToAdd" class="form-control" autocomplete="new-password" />
    </div>
  </div>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content"
  [(visible)]="showOpenEmail"
  [modal]="true"
  [style]="{ width: '50vw' }"
  appendTo="body"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ emailObject?.subject }}</h5>
    </div>
  </p-header>
  <p-dropdown
    [options]="encodage"
    [(ngModel)]="encoding"
    [placeholder]="'exchange.selectEncoding' | translate"
    (onChange)="changeEncodage()"
    [showClear]="true"
    [filter]="true">
  </p-dropdown>
  <div class="d-flex align-items-center flex-wrap mb-4 mt-3">
    @for (recipient of emailObject?.recipients; track recipient) {
      <span class="email__recipients"> {{ recipient?.type }}: {{ recipient?.email }} </span>
    }
  </div>
  <div [innerHtml]="emailObject?.bodyHtml"></div>
</p-dialog>

<p-confirmDialog
  key="shared"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'confirm' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
